import { InventoryCountRecountTaskPage } from "@/features/inventory-count/pages/InventoryCountRecountTaskPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-count/$id/recount")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_count.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountRecountTaskPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      taskId: search.taskId as string,
      type: (search.type as "add" | "edit") ?? "add",
    };
  },
});
